import script from "./KendouTopicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouTopicPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouTopicPage.vue?vue&type=style&index=0&id=c9459e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9459e2a"]])

export default __exports__